export const EMPTY_TEXT = 'No comments have been added, select "+ Add" to create one.';
export const MAX_COMMENT_LENGTH = 3000;
export const COMMENT_ROW_HEIGHT = 52;
export const COMMENT_TEXT_FIELD = 'commentText';
